module.exports = __webpack_public_path__ + "img/Guide Png.314618ac.png";